<template>
	<th @click="order" scope="col" class="order">
		{{ $t(column_heading || column_name) }}
		<i v-if="column==column_name && direction=='ASC'" class="far fa-sort-up"></i>
		<i v-if="column==column_name && direction=='DESC'" class="far fa-sort-down"></i>
	</th>
</template>

<script>
export default {
	props: ['column_name', 'column', 'direction', 'column_heading'],
	methods: {
		order() {
			let new_direction = (this.direction === 'ASC') ? 'DESC' : 'ASC';
			this.$emit('order', this.column_name, new_direction );
		}

	}
}
</script>

<style>
.order { 
	cursor: pointer;
}
</style>
